import { Chip, Divider, Group, ScrollArea, Text } from '@mantine/core';
import {
  IconAlertTriangle,
  IconBuildingBank,
  IconStar,
  IconTool,
  IconUsers,
} from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import { CONTACT_CATEGORY_KEYS, ContactCategory } from 'src/Constants/ContactCategories.constants';

import styles from './ContactFilters.module.scss';
import { Props } from './ContactFilters.types';

const CATEGORY_ICONS: Record<ContactCategory, typeof IconUsers> = {
  'Family & Community': IconUsers,
  'Professionals & Services': IconTool,
  'Emergencies & Institutions': IconBuildingBank,
};

const ContactFilters = ({
  favoritesOnly,
  emergencyOnly,
  selectedCategories,
  setFavoritesOnly,
  setEmergencyOnly,
  setSelectedCategories,
  resultCount,
}: Props) => {
  const { t } = useTranslation();
  const isAllCategoriesSelected = selectedCategories.length === 0;

  return (
    <div className={styles.container}>
      <ScrollArea className={styles.scrollArea} type="auto" offsetScrollbars="x">
        <Group className={styles.group} gap="xs">
          <Chip checked={favoritesOnly} onChange={setFavoritesOnly} variant="outline">
            <span className={styles.chipLabel}>
              <IconStar size={14} />
              {t('contacts.filters.favorites', 'Favoris')}
            </span>
          </Chip>
          <Chip checked={emergencyOnly} onChange={setEmergencyOnly} variant="outline">
            <span className={styles.chipLabel}>
              <IconAlertTriangle size={14} />
              {t('contacts.filters.emergency', 'Urgence')}
            </span>
          </Chip>
          <Divider orientation="vertical" />
          <Chip.Group multiple value={selectedCategories} onChange={setSelectedCategories}>
            {CONTACT_CATEGORY_KEYS.map(category => {
              const Icon = CATEGORY_ICONS[category];
              return (
                <Chip key={category} value={category} variant="outline">
                  <span className={styles.chipLabel}>
                    <Icon size={14} />
                    {t(`contacts.categories.${category}`, category)}
                  </span>
                </Chip>
              );
            })}
          </Chip.Group>
          <Chip
            checked={isAllCategoriesSelected}
            onChange={() => setSelectedCategories([])}
            variant="outline"
          >
            {t('contacts.filters.allCategories', 'Toutes catégories')}
          </Chip>
        </Group>
      </ScrollArea>
      {resultCount !== undefined && (
        <Text className={styles.resultCount} size="sm" c="dimmed">
          {t('contacts.filters.resultCount', '{{count}} contact(s)', { count: resultCount })}
        </Text>
      )}
    </div>
  );
};

export default ContactFilters;
